"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentActivitySortFields = void 0;
var PaymentActivitySortFields;
(function (PaymentActivitySortFields) {
    PaymentActivitySortFields["REFERENCE_NUMBER"] = "referenceNumber";
    PaymentActivitySortFields["PAYMENT_METHOD"] = "paymentMethod";
    PaymentActivitySortFields["PAYMENT_DATE"] = "paymentDate";
    PaymentActivitySortFields["ITEMS"] = "itemCount";
    PaymentActivitySortFields["CUSTOMERS"] = "customerCount";
    PaymentActivitySortFields["PAYMENT_AMOUNT"] = "totalPaymentAmount";
    PaymentActivitySortFields["STATUS"] = "status";
})(PaymentActivitySortFields = exports.PaymentActivitySortFields || (exports.PaymentActivitySortFields = {}));
